import React from "react"
import Scrollspy from "react-scrollspy"
import { Navbar, Nav } from "react-bootstrap"
import Scroller from "./scroller"
import logo from "../images/logoV2.svg"

export default class Header extends React.Component {
  constructor(props) {
    super(props)
    Scroller.handleAnchorScroll = Scroller.handleAnchorScroll.bind(this)
  }

  render() {
    return (
      <>
        <Navbar className="navbar navbar-expand-lg navbar-light fixed-top" id="mainNav" expand="lg" collapseOnSelect={true}>
          <div className="container">
            <a className="navbar-brand js-scroll-trigger" href="#page-top" onClick={Scroller.handleAnchorScroll}>
              {/* <img src={logo} alt="Kontur" onClick={Scroller.handleAnchorScroll} /> */}
              {/* Maati */}
            </a>
            <Navbar.Toggle aria-controls="navbarResponsive" />
            <Navbar.Collapse id="navbarResponsive">
              <Nav className="navbar-nav ml-auto my-2 my-lg-0">
                <Scrollspy className="navbar-nav" items={["about", "offer", "portfolio", "contact"]} currentClassName="active" rootEl={"#mainNav"} offset={-75}>
                  <li className="nav-item">
                    <Nav.Link className={"js-scroll-trigger"} href="#about" onClick={Scroller.handleAnchorScroll}>
                      Usługi
                    </Nav.Link>
                  </li>
                  <li className="nav-item">
                    <Nav.Link className={"js-scroll-trigger"} href="#offer" onClick={Scroller.handleAnchorScroll}>
                      Oferta
                    </Nav.Link>
                  </li>
                  <li className="nav-item">
                    <Nav.Link className={"js-scroll-trigger"} href="#portfolio" onClick={Scroller.handleAnchorScroll}>
                      Realizacje
                    </Nav.Link>
                  </li>
                  <li className="nav-item">
                    <Nav.Link className={"js-scroll-trigger"} href="#contact" onClick={Scroller.handleAnchorScroll}>
                      Kontakt
                    </Nav.Link>
                  </li>
                </Scrollspy>
              </Nav>
            </Navbar.Collapse>
          </div>
        </Navbar>
        <header className="masthead">
          <div className="container h-100">
            <div className="row h-100 justify-content-left align-items-start text-left">
              <div className="col-lg-10 header-title">
                <h1 className="text-uppercase font-weight-bold">
                  Jakość fundamentem <br />
                  naszej firmy
                </h1>
                {/* <hr className="divider my-4" /> */}
              </div>
              <div className="col-lg-8 header-offer">
                <h2 className="text-black font-weight-bold mb-5">
                  Złóż bezpłatne <br /> zapytanie ofertowe
                </h2>
                {/* <hr className="divider my-4" /> */}
                <a className="btn btn-primary btn-xl js-scroll-trigger" href="#contact" onClick={Scroller.handleAnchorScroll}>
                  Wypełnij formularz
                </a>
              </div>
            </div>
          </div>
        </header>
      </>
    )
  }
}
